

import { datas } from "./data"

import Card from "./Card";
import "./Education.css"

const Education = () =>{
 
  
   
    return(
        <div className="education" id="education1">
        <h1 data-aos="zoom-in"> EDUCATION & EXPERIENCE </h1>
        <div className="fake3" data-aos="zoom-in"></div>
        <nav className="had">
            <div>
                <h2 data-aos="fade-right">Education</h2>
            </div>
            <div>
                <h2 data-aos="fade-left">Experience</h2>
            </div>
        </nav>
        <nav className="tab">
      
           {
            datas.map( (data)  =>(
              <Card data={data}/>
            ) )
           }

        </nav>
        </div>
    )
}
export default Education;